import React from 'react';
import { motion } from 'framer-motion';
export function CallToAction() {
  return <section id="download" className="py-24 bg-halftone-blue relative overflow-hidden border-t-8 border-black" data-id="element-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        bounce: 0.5
      }} className="bg-white p-10 md:p-16 comic-border comic-shadow relative" data-id="element-22">
          {/* Decorative starburst */}
          <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#FFD700] comic-border comic-shadow rounded-full flex items-center justify-center rotate-12 animate-pulse" data-id="element-23">
            <span className="font-bangers text-3xl text-black text-center leading-none" data-id="element-24">
              FREE
              <br data-id="element-25" />
              APP!
            </span>
          </div>

          <h2 className="font-bangers text-6xl md:text-7xl text-black mb-6" data-id="element-26">
            Your Story Awaits
          </h2>
          <p className="font-inter text-xl md:text-2xl font-bold text-gray-800 mb-10" data-id="element-27">
            Download Comicut free and start creating today.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6" data-id="element-28">
            <a href="https://apps.apple.com/us/app/comicut/id6761404605" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-black text-white font-bangers text-3xl px-10 py-5 comic-border border-white comic-shadow hover:translate-y-1 hover:translate-x-1 hover:shadow-none transition-all" data-id="element-29">
              App Store
            </a>
            <span className="w-full sm:w-auto bg-gray-300 text-gray-600 font-bangers text-3xl px-10 py-5 comic-border border-gray-400 cursor-not-allowed opacity-70" data-id="element-30">
              Google Play — Coming Soon
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}